'use es6';

import { createSelector } from 'reselect';
import { getWelcomeMessage } from '../../selectors/widgetDataSelectors/getWelcomeMessage';
import { getGates, getLanguage, getSearchableKnowledgeBaseIds as getSearchableKnowledgeBaseIdsOperator } from '../operators/widgetDataGetters';
import { getLatestWidgetData } from './getLatestWidgetData';
export const getWidgetDataLanguage = createSelector(getLatestWidgetData, widgetData => getLanguage(widgetData));
export const getSearchableKnowledgeBaseIds = createSelector(getWelcomeMessage, welcomeMessage => getSearchableKnowledgeBaseIdsOperator(welcomeMessage));
export const getWidgetDataGates = createSelector(getLatestWidgetData, widgetData => getGates(widgetData));